import React from 'react';
import { ReactComponent as PlusIcon } from 'i/icons/plus.svg';
import { useTranslation } from 'react-i18next';

import GlassConfigTableRow from './GlassConfigTableRow';
import GlassConfigTableHeadingRow from '../GlassConfigTableHeadingRow';
import GlassConfigTotal from './GlassConfigTotal';

const GlassConfigTable = ({
	configurationData,
	isPreview,
	freezerRef,
	activeInputRowCellRef,
	glassTypeId,
	showPrice,
}) => {
	const { t } = useTranslation('commonAppValues');

	const addNewPosition = () => {
		freezerRef.current.emit('addNewPosition', { glassTypeId, inactive: true });
	};

	const glassTypeIndex = configurationData.glassTypes.findIndex(o => o.id === glassTypeId);
	const glassData = configurationData.glassTypes[glassTypeIndex];
	const { priceVolumeCat, glassTypeTotalSum } = configurationData.totals.totalGlassSizesSum;

	return (
		<div className="glass_config_table">
			{glassData.positions && glassData.positions.length ? (
				<>
					<ul className="glass_config_table__list offset_mod">
						<GlassConfigTableHeadingRow />
						{glassData.positions.map((positionRow, rowIndex) => {
							const displayPosition = `${glassTypeIndex + 1}.${rowIndex + 1}`;

							return (
								<GlassConfigTableRow
									key={positionRow.id}
									value={positionRow}
									configurationData={configurationData}
									freezerRef={freezerRef}
									activeInputRowCellRef={activeInputRowCellRef}
									glassTypeId={glassTypeId}
									rowId={positionRow.id}
									displayPosition={displayPosition}
									showPrice={showPrice}
									isPreview={isPreview}
								/>
							);
						})}
					</ul>
					<GlassConfigTotal
						{...glassTypeTotalSum[glassTypeIndex]}
						showPrice={showPrice}
						priceVolumeCat={priceVolumeCat}
					/>
				</>
			) : null}
			<div className="glass_config_add_position">
				<button className="glass_config_add_position__btn" type="button" onClick={addNewPosition}>
					<div className="glass_config_add_position__icon">
						<PlusIcon className="icon icon-plus size_mod" />
					</div>
					<div className="glass_config_add_position__title">{t('addPosition')}</div>
				</button>
			</div>
		</div>
	);
};

export default GlassConfigTable;
